import React, { Fragment } from 'react';
import { useParams } from "react-router";

// Material UI
import { Divider, Grid, Typography } from "@mui/material";
import { Box, Spinner } from '@arredo/reactjs-ui'

// Components
import Info from "../../Archings/totals/Info";

// Hooks
import useUser from '../../../hooks/user/useUser';
import useClosure from "../../../hooks/closures/useClosure";

// Models
import { cashTypesFormat, subTypesFormat, cardTypeFormat, cashTypes } from "../../../models/CashRegisterMovementEntity";
import { utils } from "../../../utils/utils";

const ClosureDetail = () => {
    const { closureId } = useParams();
    const { closure, loading } = useClosure(closureId);
    const { business } = useUser();

    const renderDescription = (detail) => {
        if (detail.cashType === "Card") {
            const card = closure?.cards?.find(c => c.id === detail.cashTypeId);
            return `${cashTypesFormat[detail.cashType]} ${card?.name} ${cardTypeFormat[card?.type]} - ${subTypesFormat[detail.subType]}`;
        } else if (detail.cashType === "Cash") {
            return cashTypesFormat[detail.cashType + detail.currency];
        }
        return cashTypesFormat[detail.cashType];
    }

    const validateAmount = (detail) =>
        detail.total > 0 || detail.real > 0

    const details = closure?.arching?.details
        ?.filter(detail => validateAmount(detail)) || []

    return (
        <>
            {loading && <Spinner lockScreen message='Cargando' />}
            {
                !loading &&
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <Box header={
                            <>
                                <Typography variant='h4'>Cierre</Typography>
                                <Typography variant='subtitle1'>{utils.formatDate(closure?.opening)}{!!closure && ' - '}{utils.formatDate(closure?.closing)}</Typography>
                            </>
                        }
                        />

                    </Grid>
                    <Grid size={12}>
                        <Box header={
                            <Typography variant='h5'>
                                <strong>Totales</strong>
                            </Typography>
                        }
                        >
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <Info
                                        color
                                        isTitles
                                        highlight
                                        price="Cotización"
                                        ingress="Total"
                                        egress="Total Real"
                                        total="Diferencia"
                                        lastClosureAmount="Apertura"
                                    />
                                </Grid>
                                {
                                    details.map((detail, index) => {
                                        return validateAmount(detail) &&
                                            <Fragment key={`detail-${index}`}>
                                                <Grid size={12}>
                                                    <Info
                                                        highlight={false}
                                                        description={renderDescription(detail)}
                                                        price={detail.cashType === "Cash" ? detail.currencyPrice : '---'}
                                                        ingress={detail.total}
                                                        egress={detail.real}
                                                        total={detail.diff}
                                                        lastClosureAmount={detail.cashType === cashTypes.cash ? detail.openingAmount : '---'}
                                                    />
                                                </Grid>
                                                {
                                                    details.length - 1 > index &&
                                                    <Grid size={12}>
                                                        <Divider light variant='middle' />
                                                    </Grid>
                                                }
                                            </Fragment>;
                                    })
                                }
                                <Grid size={12}>
                                    <Divider />
                                </Grid>
                                {
                                    closure && closure.arching && closure.arching.details &&
                                    business?.currencies?.map((curr, index) => {
                                        const items = closure.arching.details.filter(d => d.currency === curr);

                                        return (
                                            <Fragment key={curr}>
                                                <Grid size={12}>
                                                    <Info
                                                        highlight
                                                        description={`Subtotal ${curr}:`}
                                                        price='---'
                                                        lastClosureAmount='---'
                                                        ingress={items.reduce((a, b) => a + b.total * b.currencyPrice, 0)}
                                                        egress={items.reduce((a, b) => a + b.real * b.currencyPrice, 0)}
                                                        total={items.reduce((a, b) => a + b.diff * b.currencyPrice, 0)}
                                                    />
                                                </Grid>
                                                {
                                                    business?.currencies.length - 1 > index &&
                                                    <Grid size={12}>
                                                        <Divider light variant='middle' />
                                                    </Grid>
                                                }
                                            </Fragment>
                                        );
                                    })
                                }
                                <Grid size={12}>
                                    <Divider />
                                </Grid>
                                <Grid size={12}>
                                    <Info
                                        highlight
                                        description='Total:'
                                        price='---'
                                        lastClosureAmount='---'
                                        ingress={closure?.arching?.total}
                                        egress={closure?.arching?.real}
                                        total={closure?.arching?.diff}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default ClosureDetail;